// Angular imports
import { Component, Injector, OnInit, ViewChild } from '@angular/core';

// CC-Common imports
import { Utils } from 'cc-common';

// devextreme imports
import { DxDataGridComponent } from 'devextreme-angular';

// Component imports
import { UserCommunitiesBaseComponent } from '../_base/user-communities-base.component';
import { IInteractiveDashboardComponent } from '../../dashboard-module/_interfaces/interactive-dashboard-component';
import { UserContextTreeComponent } from '../../shared-module/user-context-tree/user-context-tree.component';

// Service imports
import { SharedWidgetsService } from '../../shared-widgets-module/_services/shared-widgets.service';
import { UserCommunitiesService } from '../_services/user-communities.service';
import { PortfolioHelperService } from '../_services/portfolio-helper.service';

// Model imports
import { UserCommunitiesResultDto } from '../_models/user-communities/user-communities-result-dto';
import { ICommunityContextDashboardComponent } from '../../dashboard-module/_interfaces/community-context-component';

@Component({
    selector: 'app-user-communities',
    templateUrl: './user-communities.component.html',
    styleUrls: ['./user-communities.component.scss']
})
export class UserCommunitiesComponent
    extends UserCommunitiesBaseComponent
    implements OnInit, ICommunityContextDashboardComponent, IInteractiveDashboardComponent
{
    @ViewChild('communityGrid', { static: false }) communityGrid: DxDataGridComponent;
    @ViewChild('communityContextTree', { static: false }) communityContextTree: UserContextTreeComponent;

    communities: UserCommunitiesResultDto[];

    hideTitle = true;
    minWidthRatio = 30;
    minHeightRatio = 30;
    minWidth = 990;
    minHeight = 480;
    hideFullScreen = false;
    widgetId: string;

    selectedContextKey: string;
    contextTreeBoxValue: Array<string> = [];

    loadingVisible: boolean;

    filterRowColCount = 8;

    constructor(
        protected readonly injector: Injector,
        protected readonly sharedWidgetService: SharedWidgetsService,
        protected readonly communitiesService: UserCommunitiesService,
        private readonly portfolioService: PortfolioHelperService
    ) {
        super(injector, sharedWidgetService, communitiesService);

        this.portfolioService.onLoadingEvent().subscribe((flag) => {
            setTimeout(() => (this.loadingVisible = flag), 10);
        });
    }

    ngOnInit(): void {
        super.ngOnInit();
    }

    refresh(width: number, height: number): void {
        if (width < this.minWidth) {
            const colCount = Math.round(width / 180);

            if (Utils.equals(colCount, 3)) {
                this.filterRowColCount = 4;
            } else {
                this.filterRowColCount = colCount;
            }
        } else {
            this.filterRowColCount = 8;
        }
    }

    getTitle(name: string): string {
        return name;
    }

    setCommunity(communityId: number, managementCompanyId: number, communityName: string): void {
        if (!!communityId) {
            if (Utils.notNullAndDefined(this.communityGrid) && Utils.notNullAndDefined(this.communityGrid.instance)) {
                this.communityContextTree.repaint();
                this.communityGrid.instance.filter(['communityId', '=', communityId]);
                this.selectedContextKey = `C${communityId}`;
                this.contextTreeBoxValue = [this.selectedContextKey];
            }
        } else {
            if (Utils.notNullAndDefined(this.communityGrid) && Utils.notNullAndDefined(this.communityGrid.instance)) {
                this.communityGrid.instance.clearFilter();
                this.selectedContextKey = null;
                this.contextTreeBoxValue = [];
            }
        }
    }

    doRefresh(clearCache = false): void {
        this.filterParams.clearCache = clearCache;
        this.portfolioHelper.showLoading();
        this.communitiesService.getUserCommunities(this.filterParams).subscribe(
            (results: UserCommunitiesResultDto[]) => {
                this.communities = results;
                this.portfolioHelper.hideLoading();
            },
            (error) => {
                this.errorService.displayError(error);
                this.portfolioHelper.hideLoading();
            }
        );
    }

    onCommunityClick(rec: UserCommunitiesResultDto): void {
        this.helperService.openDefaultCommunityPageInNewWindow(rec.communityId);
    }

    onViewServicesClick(rec: UserCommunitiesResultDto): void {
        rec.showServices = false;
        if (Utils.notNullAndDefined(rec.communityServices)) {
            setTimeout(() => (rec.showServices = true), 100);
        } else {
            this.communitiesService.getCommunityServices(rec.communityServicesUrl).subscribe(
                (result: string[]) => {
                    rec.communityServices = result.join('<br />');
                    rec.showServices = true;
                },
                (error) => {
                    this.errorService.displayError(error);
                }
            );
        }
    }

    getStatus(rowData: UserCommunitiesResultDto, status: string): string {
        const date = this.helperService.getDateString(rowData.terminatingDate);
        return Utils.isTrue(rowData.isTerminating) && Utils.notEqualsIgnoreCase(rowData.status, 'Terminated')
            ? `Community will terminate on ${date}`
            : status;
    }

    customizeContextLabel(selected: any[]): string {
        if (selected.length > 1) {
            return `${selected.length} Communities Selected`;
        } else if (selected.length === 1) {
            return selected[0].title;
        }
        return null;
    }
}
